'use client';

/**
 * "Open Axel AI Assisted" — a button that opens the assistant.
 *
 * Annette, 22 Oct 2026: "the inpage Axel AI Assisted - if you click open Axel AI Assisted - it
 * opens another page - shouldnt it open the assistant?"
 *
 * It was `<ButtonLink href="/axel-ai-assisted">`, which navigates to the page ABOUT the
 * assistant — a page that then shows the same card again. So the control named "Open" opened
 * nothing: it took the visitor away from the assistant that was already on screen, and asked
 * them to find it a second time. It now does what it says, through the same handoff the card
 * uses. The page about the assistant is still linked, under a name that says it is a page.
 */

import { Button } from '@/components/brand/Button';
import { openAssistant } from './openAssistant';

export function OpenAssistantButton({
  children = 'Open Axel AI Assisted',
  variant = 'secondary',
  className = '',
}: {
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}) {
  return (
    <Button variant={variant} className={className} onClick={() => openAssistant()}>
      {children}
    </Button>
  );
}
